import { globalPrompt } from "@/components/message";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { convertRes2Blob } from "@/utils/exportFile";
import { TablePaginationConfig } from "antd/lib/table";
import { createModel } from "hox";
import { useState } from "react";
import { inquiryResultService } from "./inquiryResultService";
import { IInquiryResultDetail, IInquiryResultSearchFields } from "./inquiryResultTypes";

export const useInquiryResultModel = createModel(function () {
    const {setLoadingInfo } = useGlobalModel();
    const initSearch = { }
    //查询条件
    const [searchParam, setSearchParam] = useState<IInquiryResultSearchFields>(initSearch);
    //列表数据源
    const [dataSource, setDataSource] = useState<IInquiryResultDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<boolean>(false);

    const updateSearchParam = (updateParam: IInquiryResultSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }


    //重置
    const resetSearchParam = () => {
        setSearchParam(initSearch);
        setSelectedRowKeys([]);
        loadData(initPgCfg, initSearch);
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IInquiryResultSearchFields = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await inquiryResultService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
    }
   
  

    //导出模版
    const exportTemplate = async () => {
         if (selectedRowKeys.length !== 1) {
            //没有
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let resultCode = dataSource.find((item) => item.id === selectedRowKeys[0])?.resultCode;
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await inquiryResultService.exportTemplate({resultCode: resultCode!});
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    };

    return {
       /***field***/
       searchParam,
       dataSource,
       selectedRowKeys,
       pgCfg,
       loading,
       /***method***/
       setDataSource,
       setSelectedRowKeys,
       resetSearchParam,
       updateSearchParam,
       loadData,
       exportTemplate
    }
});